var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',{staticClass:"account-message"},[_vm._v("You have no active plan")]),_vm._m(0),_c('router-link',{staticClass:"btn",attrs:{"to":"/my-account/"}},[_vm._v("My Account")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"message"},[_vm._v("Please activate or buy a plan"),_c('br')])
}]

export { render, staticRenderFns }